import {
    SERVICE_PLAN_ADD_ERROR,
    SERVICE_PLAN_ADD_START,
    SERVICE_PLAN_ADD_SUCCESS,
} from '../../constants';
import history from '../../core/history';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { updateServicePlans } from '../../lib/graphql';
import { setLoaderComplete, setLoaderStart } from '../loader/loader';

export function updateServicePlansAction(values) {
    return async (dispatch, getState, { client }) => {

        await dispatch({ type: SERVICE_PLAN_ADD_START });
        dispatch(setLoaderStart('updateServicePlanLoading'));
        try {
            const aiFeaturesStatus =
                values?.aiFeaturesStatus === true ||
                values?.aiFeaturesStatus === 'true';
            const dynamicServicePlans = values?.dynamicServicePlans?.length > 0 ? JSON.stringify(values.dynamicServicePlans) : JSON.stringify([]);

            const { data } = await client.mutate({
                mutation: updateServicePlans,
                variables: {
                    id: Number(values?.id),
                    userType: values?.userType,
                    planName: values?.dynamicServicePlans?.[0]?.planName,
                    duration: values?.duration,
                    currency: values?.currency,
                    description: values?.dynamicServicePlans?.[0]?.description,
                    price: Number(values?.price),
                    serviceFee: Number(values?.serviceFee),
                    mediaImage: values?.mediaImage,
                    aiFeaturesStatus,
                    isEnable: values?.isEnable,
                    dynamicServicePlans: dynamicServicePlans,
                }
            });
            if (data?.updateServicePlans?.status === 200) {
                await dispatch({
                    type: SERVICE_PLAN_ADD_SUCCESS,
                });
                history.push('/siteadmin/service-plans');
                showToaster({ messageId: values?.id ? 'servicePlanUpdate' : 'servicePlanAdd', toasterType: 'success' })
                dispatch(setLoaderComplete('updateServicePlanLoading'));
            } else {
                dispatch(setLoaderComplete('updateServicePlanLoading'));
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.updateServicePlans?.errorMessage })
                await dispatch({
                    type: SERVICE_PLAN_ADD_ERROR,
                    payload: {
                        error: data?.updateServicePlans?.errorMessage
                    }
                });
            }

        } catch (error) {
            dispatch(setLoaderComplete('updateServicePlanLoading'))
            await dispatch({
                type: SERVICE_PLAN_ADD_ERROR,
                payload: {
                    error
                }
            });
        }
    }
}


